<script>
  import { useNavigate } from "svelte-navigator";
  import { onMount } from "svelte";
  import Icon, { Search } from "svelte-hero-icons";
  import Form from "../components/form/Form.svelte";
  import Select from "svelte-select";
  import TextArea from "../components/form/TextAreaJson.svelte";
  import { Moon } from "svelte-loading-spinners";

  import Validators from "../utils/validators";
  import { headerDisplayStore } from "../stores/General";
  import { getList,getById } from "../api";
  const navigate = useNavigate();
  const module_name = "publisher";
  const module = "bid_request";
  let loading = false;
  let Publishertems = [];
  let bidRequestData;
  let bidResponseData;
  let demandValue;
  let publisherValue;
  let DemandPartnersitems = [];
  let submitLoad = false;
  onMount(() => {
    fetchDemandPartners()
    headerDisplayStore.SetTitle("Bid Sample");
    headerDisplayStore.SetBreadCrumbs([
      {
        key: "bid_sample",
        label: "Bid Sample",
      },
      {
        key: "new",
        label: "New",
      },
    ]);
  });


  async function fetchDemandPartners(name = undefined) {
    loading = true;
    try {
      const response = await getList('demand', 10, 1, 'name', 'ASC', { name });
      if (response?.data) {
        loading = false;
        DemandPartnersitems = response.data.map((item) => {
          return { value: item.demand_partner_id, label: item.name };
        });
      }
    } catch (error) {
      console.warn(error);
      return [];
    }
  }
  getList(module_name, 10, 1, "name", "ASC", {})
            .then((response) => {
                if (response?.data) {
        loading = false;
        Publishertems = response.data.map((item) => {
          return { value: item.publisher_id, label: item.name };
        });
      }
            })
            .catch((error) => {
                loading = false;
                headerDisplayStore.ShowError({
                    title: 'Server error',
                    subtitle: error?.message,
                });
            });
  let form;
  let rules = {
    name: {
      validators: [Validators.required, Validators.minLength(4)],
    },
  };

  //onInput detect for demand
  function handleDp(event, i) {
    if (event.detail.value !== event.detail.label) {
      demandValue = event.detail.value;
    }
  }

  function handlePub(event, i) {
    if (event.detail.value !== event.detail.label) {
      publisherValue = event.detail.value;
    }
  }

 async  function onSubmit(e) {
     if (publisherValue) {
        submitLoad = true
        try {
      submitLoad = true;
      let  response = await getById('bid_request', publisherValue);
      if (response) {
        bidRequestData = response?.bidrequest;
        submitLoad = false
        publisherValue = ""
      } 
    } catch (error) {
      headerDisplayStore.ShowError({
          title: 'Error',
          subtitle: "No data was found",
        });
        publisherValue = ""
        bidRequestData
    } finally {
      submitLoad = false;
    }
   }

   if (demandValue) {
    submitLoad = true
       try {
      submitLoad = true;
      let  response = await getById('bid_response', demandValue);
      if (response) {
        bidResponseData = response?.bidresponse;
           submitLoad = false
           demandValue = ""
      } 
    } catch (error) {
      headerDisplayStore.ShowError({
          title: 'Error',
          subtitle: "No data was found",
        });
        demandValue = ""
        bidResponseData =""
    } finally {
      submitLoad = false;
    }
   }
   
  }

  $: isEmpty = !publisherValue;

</script>

<div class="w-full sm:px-6">
  <div class="py-2 md:py-2">
    <Form {rules} on:submit={onSubmit} bind:this={form}>
    <div class="flex w-full items-center justify-center">
       <div class="flex flex-1 w-full mr-2">
        <div class="flex flex-col items-center w-full mr-2">
          <div class="flex flex-col items-center w-full mr-2">
            <div class="flex flex-col w-full justify-center">
              <div>Publisher</div>
              <div
                class="inline-block focus:ring-yellow-500 focus:border-yellow-500 shadow-sm w-100 mb-4 h-12 sm:text-sm border-gray-300 rounded-md"
              >
                <Select
                items={Publishertems}
                on:select={(event)=>handlePub(event)}
                isWaiting={loading}
                />
              </div>
            </div>
          </div>
            
          </div>
          <div class="flex flex-col w-full justify-center">
            <div>Demand Partner</div>
            <div
              class="inline-block focus:ring-yellow-500 focus:border-yellow-500 shadow-sm w-100 mb-4 h-12 sm:text-sm border-gray-300 rounded-md"
            >
              <Select 
              items={DemandPartnersitems}
              on:select={(event) => handleDp(event)}
              isWaiting={loading}
              />
            </div>
          </div>

       </div>
      <div class="flex flex-col items-center ml-2">
        <button
          type="submit"
          disabled={submitLoad}
          class="w-48 h-12 relative inline-flex items-center justify-center px-1 py-1 rounded-md border shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white hover:bg-custom-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
        >
        {#if submitLoad}
        <Moon size="1" color="#FFFF" unit="rem" duration="1s" />
        {:else}
        <Icon src={Search} class="mr-2.5 h-5 w-5 text-white" solid />
        {/if}
          <span class="text-white">{submitLoad ? " Searching..." : " Search"}</span>
        </button>
      </div>
    </div>
    

    <div class="flex bg-white px-5 pb-8 pt-5   rounded-2xl mb-10 w-full justify-center items-center gap-2">
      <div class="flex flex-col items-center w-full flex-auto">
        <TextArea
            label="Bid Request"
            name="bid_request"
            value={bidRequestData != "" ?JSON.stringify(bidRequestData,undefined,4):""}
            isBidTemplate
        />
    </div>
    <div class="flex flex-col items-center w-full flex-auto">
        <TextArea
            label="Bid Response"
            name="bid_response"
            initialValue=""
            isBidTemplate
            value={bidResponseData != "" ? JSON.stringify(bidResponseData,undefined,4) :""}

        />
    </div>
    </div>
</Form>
  </div>
</div>
